/**
 * usePageTracking フック
 *
 * ページ遷移を追跡してAnalyticsLoggerに記録する。
 *
 * Requirements:
 * - 6.10: ページ遷移時に navigation.page_view イベントを記録
 */

import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import { AnalyticsLogger } from '../lib/analytics';

/**
 * ページ遷移を追跡するフック
 * BrowserRouter内で使用する必要がある
 */
export function usePageTracking(): void {
  const location = useLocation();
  const previousPathRef = useRef<string>('');

  useEffect(() => {
    const currentPath = location.pathname;
    const previousPath = previousPathRef.current;

    // 初回ロード時は記録しない（前のパスがない）
    if (previousPath && previousPath !== currentPath) {
      AnalyticsLogger.getInstance().trackPageView(previousPath, currentPath);
    }

    previousPathRef.current = currentPath;
  }, [location.pathname]);
}
